// extracted by mini-css-extract-plugin
export var badge = "DevToolsBadge-module--badge--74a3d";
export var dot = "DevToolsBadge-module--dot--3af6c";
export var hint = "DevToolsBadge-module--hint--032c8";